import api from "../providers/api";

export const getFile = async file => {
  const response = await api.attachment.getById(file.ID);
  const newFile = { ...file };
  newFile.localURL = URL.createObjectURL(response.data);
  return newFile;
};

export const getUserImage = async user => {
  const response = await api.attachment.getUserImage(user);
  const newFile = { ...user };
  newFile.localURL = URL.createObjectURL(response.data);
  return newFile;
};

export const downloadFile = async file => {
  const tempFile = file.localURL ? file : await getFile(file);
  const a = document.createElement("a");
  a.style.display = "none";
  a.href = tempFile.localURL;
  a.download = tempFile.FileName;
  document.body.appendChild(a);
  return a.click();
};
